import { Endpoints, fetch, normalizeKeys, post, put } from '../api'
import { AxiosError } from 'axios'
import msgpack5 from 'msgpack5'

const msgpack = msgpack5()

export const postUserLogin = async () => {
  const uri = `${Endpoints.User}/Login`
  const data = await post(uri)
  if (!data) throw new AxiosError('No data returned from api')
  return data
}

/**
 *
 * @param userPreferences
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const putUserPreferences = async userPreferences => {
  const uri = `${Endpoints.User}/Preferences`
  const preparedData = JSON.stringify(userPreferences)
  const encodedData = msgpack.encode(preparedData)
  const data = await put(uri, encodedData, {
    headers: {
      'Content-Type': 'application/x-msgpack',
    },
  })
  if (!data) throw new AxiosError('No data returned from api')
  return data
}

/**
 * Fetches the user preferences from the current logged user
 * @returns {Promise<any>}
 */
export const fetchUserPreferences = async () => {
  const uri = `${Endpoints.User}/Preferences`
  const response = await fetch(uri)
  /**
   * TODO: this is a workaround due to the fact that the api returns a string
   */
  const data = JSON.parse(response.data)
  return normalizeKeys(data)
}

export const fetchPermissions = async ({ productId = 'pa', planId = 999 }) => {
  const uri = `${Endpoints.Permission}/${productId}/${planId}`
  const response = await fetch(uri)
  return normalizeKeys(response.data)
}

export const putPermissions = async ({
  permissions,
  productId = 'pa',
  planId = 4888,
}) => {
  const uri = `${Endpoints.Permission}/${productId}/${planId}`
  const encodedData = msgpack.encode(permissions)
  const response = await put(uri, encodedData)
  return response
}
